import global from '../../../shared/utils/global.js';
import { fetchServiceAgentAccounts, setServiceAgentAccount } from "../../auth/views/login/auth.api.js";


import { hideModal, showModal } from '../../../shared/components/modal.js';
let activeCustomerId = null;

const waitForCustomerSelection = () => {
  return new Promise((resolve) => {
    window.setServiceAgentCustomerAccount = async (customerId) => {
      try {
        await setServiceAgentAccount(customerId);
        activeCustomerId = customerId;
        global.customerId = activeCustomerId;
        hideModal('serviceagentcustomermodal');
        resolve(customerId);
      } catch (error) {
        console.error("Failed to set service agent account:", error);
      }
    };
  });
};

const populateServiceAgentCustomers = async () => {
  const accounts = await fetchServiceAgentAccounts();
  const tableBody = document.getElementById('serviceagentcustomertable');
  tableBody.innerText = '';

  accounts.forEach(acc => {
    const row = document.createElement('tr');
    row.style.cursor = 'pointer';
    row.setAttribute('title', 'Click to select this account');

    // Bootstrap 4 highlight
    if (acc.customerId === activeCustomerId) {
      row.classList.add('selected-service-account-row');
    }

    row.addEventListener('click', () => {
      window.setServiceAgentCustomerAccount(acc.customerId);
    });

    const tdName = document.createElement('td');
    tdName.textContent = acc.customerName;

    if (acc.customerId === activeCustomerId) {
      const checkContainer = document.createElement('span');
      checkContainer.className = 'check-circle';
      tdName.appendChild(document.createTextNode(' ')); // space before the circle
      tdName.appendChild(checkContainer);
    }

    const tdAccess = document.createElement('td');
    tdAccess.textContent = acc.accessLevel;

    row.appendChild(tdName);
    row.appendChild(tdAccess);

    tableBody.appendChild(row);

  });
};

export const showServiceAgentCustomerModal = async () => {
  await populateServiceAgentCustomers();
  showModal('serviceagentcustomermodal', { backdrop: 'static', keyboard: false });

  const splashContainer = document.getElementById('splashcontainer');
  if (splashContainer) splashContainer.style.display = 'none';
  const unitsContainer = document.getElementById('unitscontainer');
  if (unitsContainer) unitsContainer.style.display = 'none';
  // document.getElementById('mainpane').style.display = 'none';
  // document.getElementById('detailspane').style.display = 'none'
  const selectedCustomerId = await waitForCustomerSelection();
  return selectedCustomerId;
};
